<template>
<div data-component="PwaDialog.vue" class="pwa-prompt" @click="Cancel('backdrop')">
	<ModalDialog class="is-dialog is-from-bottom" :Visible="Shown">
		<div class="p-5" @click.stop @wheel.prevent>
			<div class="flex items-center mb-5">
				<BaseIcon class="flex-none mr-3" size="2.5" set="twotone" name="smartphone"/>
				<div class="heading-small" style="font-size: 18px;">
					Docieraj do Klientów szybciej z&nbsp;aplikacją&nbsp;mobilną!
				</div>
			</div>
			<button class="btn btn-primary w-full mb-3" @click="Confirm">
				{{ IsSafari ? 'Pobierz w App Store' : 'Pobierz w sklepie Play' }}
			</button>
			<button class="btn w-full" @click.prevent="Cancel('button')">
				Kontynuuj w przeglądarce
			</button>
		</div>
	</ModalDialog>
</div>
</template>

<script lang="ts">
import * as mobileApp from '../../globals/utilities/MobileApp';

// @vuese
// Komponent odpowiedzialny za wyświetlenie pytania o instalację PWA.
// @group Base Components
export default {
	name: 'PwaDialog',
	data() {
		return {
			DefferedPrompt: null,
			Shown: false,
			AnalyticsLabel: '',
			TimesClicked: 0,
			IsSafari: false,
		};
	},
	mounted() {
		window.addEventListener('beforeinstallprompt', (e) => {
			e.preventDefault();
			window['DefferedPrompt'] = e;
			this.DefferedPrompt = e;
			this.Show();
		});
		this.Show();
	},
	methods: {
		Show() {
			return;

			window.setTimeout(() => {
				const mobileDeviceType = mobileApp.canShowDownloadAppPrompt();
				const isIllegalModule = this.$root.Module === 'RfpForm' || this.$root.Module === 'BuyerView' || this.$root.Module === 'LoginRegister';
				if (this.ScreenSize > 1 || !mobileDeviceType || isIllegalModule) { return; }

				const isSafari = mobileDeviceType === 'Safari';
				this.IsSafari = isSafari;

				let pwaPrompt = { times: 0, date: new Date() };
				if (window.localStorage.AppPwaPrompt && !window.localStorage.AppPwaPromptIgnoreDate) {
					pwaPrompt = JSON.parse(window.localStorage.AppPwaPrompt, (k, v) => (k === 'date' ? new Date(v) : v));

					const addDays = (pwaPrompt.times % 4 === 0) ? 14 : 2;
					const displayAfter = new Date(pwaPrompt.date.valueOf());
					displayAfter.setDate(displayAfter.getDate() + addDays);
					if (displayAfter > new Date()) { return; }
				}

				this.AnalyticsLabel = `${this.$root.Module}/${(this.State || {}).CurrentStateName}`;
				window.setTimeout(() => {
					this.Shown = true;
					window.localStorage.AppPwaPrompt = JSON.stringify({ times: pwaPrompt.times + 1, date: new Date() });
				}, 500);
			}, 4000);
		},
		Confirm() {
			this.TimesClicked++;
			if (this.TimesClicked > 2) {
				this.Shown = false;
				return;
			}

			try {
				mobileApp.goToStore();

				this.Shown = false;
			} catch (err) {
				console.error(err);
			}
		},
		Cancel(source) {
			source = (source === 'button') ? 'kontynuuj w przeglądarce' : 'klik poza obszar';
			this.Shown = false;
		},
	},
};
</script>

<style lang="scss">

</style>
